// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/pages/MajorWishListNew/OperationBtn.less
// module id = 944
// module chunks = 0